// Shared site data — İzmir Medya
export const CONTACT = {
  phone: "0551 628 27 21",
  phoneRaw: "905516282721",
  instagram: "@izmir.medyaa",
  instagramUrl: "https://instagram.com/izmir.medyaa",
  email: "info@izmir35medya.com",
  city: "İzmir, Türkiye",
};

export const EKTIREN = {
  name: "Ektiren Project",
  tagline: "Web Tasarım & Dijital Geliştirme",
  phone: "+90 539 117 1883",
  phoneRaw: "905391171883",
};

export const waLink = (raw, text) =>
  `https://wa.me/${raw}?text=${encodeURIComponent(text)}`;

export const NAV = [
  { label: "Ana Sayfa", path: "/" },
  { label: "Hakkımızda", path: "/hakkimizda" },
  { label: "Hizmetler", path: "/hizmetler" },
  { label: "Referanslar", path: "/referanslar" },
  { label: "Paketler", path: "/paketler" },
  { label: "İletişim", path: "/iletisim" },
];

export const PORTFOLIO_CATEGORIES = [
  { key: "all", label: "Tümü" },
  { key: "sosyal", label: "Sosyal Medya" },
  { key: "cekim", label: "Çekim & Prodüksiyon" },
  { key: "reklam", label: "Reklam" },
  { key: "icerik", label: "İçerik & Reels" },
];

export const PORTFOLIO = [
  { id: 1, title: "Kahve Markası Lansmanı", client: "@aegean.coffee", cat: "sosyal", metric: "+180% Etkileşim", img: "https://images.unsplash.com/photo-1620313924455-70c030910dcf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxzb2NpYWwlMjBtZWRpYSUyMGNvbnRlbnQlMjBjcmVhdGlvbiUyMGZsYXRsYXl8ZW58MHx8fHwxNzg3MDkzMjkwfDA&ixlib=rb-4.1.0&q=85" },
  { id: 2, title: "Ürün Çekimi & Katalog", client: "@lumiere.skincare", cat: "cekim", metric: "120 Ürün Karesi", img: "https://images.unsplash.com/photo-1772191530787-b9546da02fbc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxwcm9kdWN0JTIwcGhvdG9ncmFwaHklMjBzdHVkaW8lMjBicmFuZGluZ3xlbnwwfHx8fDE3ODcwOTMyOTB8MA&ixlib=rb-4.1.0&q=85" },
  { id: 3, title: "Restoran İçerik Yönetimi", client: "@bornova.bistro", cat: "sosyal", metric: "+9K Takipçi", img: "https://images.unsplash.com/photo-1483648969698-5e7dcaa3444f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxjYWZlJTIwcmVzdGF1cmFudCUyMGZvb2QlMjBpbnN0YWdyYW18ZW58MHx8fHwxNzg3MDkzMjkwfDA&ixlib=rb-4.1.0&q=85" },
  { id: 4, title: "Parfüm Reklam Kampanyası", client: "@elysee.parfum", cat: "reklam", metric: "3.2x ROAS", img: "https://images.unsplash.com/photo-1652262147172-142284cf5a6f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxwcm9kdWN0JTIwcGhvdG9ncmFwaHklMjBzdHVkaW8lMjBicmFuZGluZ3xlbnwwfHx8fDE3ODcwOTMyOTB8MA&ixlib=rb-4.1.0&q=85" },
  { id: 5, title: "Reels İçerik Serisi", client: "@fit.studio.izmir", cat: "icerik", metric: "850K Görüntüleme", img: "https://images.pexels.com/photos/31078822/pexels-photo-31078822.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { id: 6, title: "Cafe Mekan Çekimi", client: "@karsiyaka.roastery", cat: "cekim", metric: "Full Prodüksiyon", img: "https://images.unsplash.com/photo-1588501302210-35efea6d97ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxjYWZlJTIwcmVzdGF1cmFudCUyMGZvb2QlMjBpbnN0YWdyYW18ZW58MHx8fHwxNzg3MDkzMjkwfDA&ixlib=rb-4.1.0&q=85" },
  { id: 7, title: "Meta Reklam Yönetimi", client: "@moda.evi", cat: "reklam", metric: "-42% Tıklama Maliyeti", img: "https://images.pexels.com/photos/36540512/pexels-photo-36540512.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { id: 8, title: "Ürün Lansman İçeriği", client: "@daily.brew", cat: "icerik", metric: "+240% Erişim", img: "https://images.unsplash.com/photo-1546177461-668e7784915e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxzb2NpYWwlMjBtZWRpYSUyMGNvbnRlbnQlMjBjcmVhdGlvbiUyMGZsYXRsYXl8ZW58MHx8fHwxNzg3MDkzMjkwfDA&ixlib=rb-4.1.0&q=85" },
  { id: 9, title: "Gastronomi İçerik", client: "@alacati.kitchen", cat: "sosyal", metric: "+15K Takipçi", img: "https://images.unsplash.com/photo-1564759224907-65b945ff0e84?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxjYWZlJTIwcmVzdGF1cmFudCUyMGZvb2QlMjBpbnN0YWdyYW18ZW58MHx8fHwxNzg3MDkzMjkwfDA&ixlib=rb-4.1.0&q=85" },
];

export const INSTAGRAM_POSTS = [
  { img: "https://images.unsplash.com/photo-1546177461-668e7784915e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxzb2NpYWwlMjBtZWRpYSUyMGNvbnRlbnQlMjBjcmVhdGlvbiUyMGZsYXRsYXl8ZW58MHx8fHwxNzg3MDkzMjkwfDA&ixlib=rb-4.1.0&q=85", likes: "1.2K", comments: "84" },
  { img: "https://images.unsplash.com/photo-1629385359375-886444e67724?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxzb2NpYWwlMjBtZWRpYSUyMGNvbnRlbnQlMjBjcmVhdGlvbiUyMGZsYXRsYXl8ZW58MHx8fHwxNzg3MDkzMjkwfDA&ixlib=rb-4.1.0&q=85", likes: "980", comments: "51" },
  { img: "https://images.pexels.com/photos/10776437/pexels-photo-10776437.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", likes: "2.4K", comments: "132" },
  { img: "https://images.unsplash.com/photo-1483648969698-5e7dcaa3444f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxjYWZlJTIwcmVzdGF1cmFudCUyMGZvb2QlMjBpbnN0YWdyYW18ZW58MHx8fHwxNzg3MDkzMjkwfDA&ixlib=rb-4.1.0&q=85", likes: "1.8K", comments: "97" },
  { img: "https://images.unsplash.com/photo-1564759224907-65b945ff0e84?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxjYWZlJTIwcmVzdGF1cmFudCUyMGZvb2QlMjBpbnN0YWdyYW18ZW58MHx8fHwxNzg3MDkzMjkwfDA&ixlib=rb-4.1.0&q=85", likes: "3.1K", comments: "210" },
  { img: "https://images.unsplash.com/photo-1772191530787-b9546da02fbc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxwcm9kdWN0JTIwcGhvdG9ncmFwaHklMjBzdHVkaW8lMjBicmFuZGluZ3xlbnwwfHx8fDE3ODcwOTMyOTB8MA&ixlib=rb-4.1.0&q=85", likes: "1.5K", comments: "73" },
];

export const FAQ = [
  { q: "Paketler aylık mı, tek seferlik mi?", a: "Tüm paketlerimiz aylık aboneliktir. Uzun vadeli zorunluluk yoktur; performansı gördükçe dilediğiniz zaman paketinizi yükseltebilirsiniz." },
  { q: "Gerçekten bot kullanmıyor musunuz?", a: "Kesinlikle. Tüm büyüme %100 organik ve gerçek kullanıcı etkileşimine dayalıdır. Sahte takipçi veya bot asla kullanmayız; hedefimiz gerçek müşteri kazandırmaktır." },
  { q: "Çekimler nerede yapılıyor?", a: "İzmir ve çevresinde işletmenizde yerinde çekim yapıyoruz. İhtiyaca göre stüdyo, mekan ve drone çekimleri de organize ediyoruz." },
  { q: "Reklam bütçesi (ad spend) pakete dahil mi?", a: "Reklam yönetimi ve kampanya kurulumu paketlere dahildir. Meta/Google'a ödenen reklam harcaması ise ayrıdır ve tamamen sizin kontrolünüzdedir." },
  { q: "Ne kadar sürede sonuç alırım?", a: "İlk 30 gün içinde ölçülebilir etkileşim ve erişim artışı hedefliyoruz. Her ay detaylı performans raporu ile ilerlemenizi şeffafça paylaşırız." },
  { q: "Hangi platformları yönetiyorsunuz?", a: "Instagram, Facebook, TikTok ve YouTube içerik yönetimi ile Google İşletme Profili optimizasyonu sağlıyoruz." },
  { q: "Nasıl başlıyoruz?", a: "WhatsApp'tan bize yazın; ücretsiz keşif görüşmesi yapalım. Markanıza en uygun paketi ve size özel bir teklifi birlikte belirleyelim." },
];


export const SERVICES = [
  {
    id: "sosyal-medya",
    title: "Sosyal Medya Yönetimi",
    icon: "Share2",
    desc: "Instagram & Facebook hesaplarınızı uçtan uca yönetiyoruz. İçerik planı, paylaşım takvimi ve topluluk yönetimi.",
    points: ["İçerik planlama & takvim", "Topluluk & DM yönetimi", "Profil optimizasyonu"],
  },
  {
    id: "cekim",
    title: "Profesyonel Çekimler",
    icon: "Camera",
    desc: "Sinema kalitesinde fotoğraf ve video çekimi. Markanızı en iyi ışıkta gösteren prodüksiyon.",
    points: ["Ürün & mekan çekimi", "Reels & video prodüksiyon", "Kurgu & renk düzenleme"],
  },
  {
    id: "icerik",
    title: "İçerik Üretimi & Strateji",
    icon: "Sparkles",
    desc: "Algoritmayı besleyen, dönüşüm getiren içerik stratejisi. Rakip analizi ve büyüme planı.",
    points: ["İçerik stratejisi", "Rakip & trend analizi", "Büyüme yol haritası"],
  },
  {
    id: "drone",
    title: "FPV & Drone Çekimi",
    icon: "Plane",
    desc: "4K drone ile nefes kesen hava çekimleri. Mekanınızı ve etkinliklerinizi gökyüzünden anlatın.",
    points: ["4K hava çekimi", "FPV dinamik geçişler", "Etkinlik & mekan"],
  },
  {
    id: "reklam",
    title: "Meta & Google Reklam",
    icon: "Target",
    desc: "Bütçenizi boşa harcamadan, sonuç odaklı reklam yönetimi. Doğru kitleye doğru mesaj.",
    points: ["Meta Business Suite", "Google İşletme Profili", "Performans raporlama"],
  },
  {
    id: "kurgu",
    title: "Prodüksiyon & Kurgu",
    icon: "Clapperboard",
    desc: "Ham görüntüyü akılda kalan hikayeye dönüştüren profesyonel kurgu ekibi.",
    points: ["Reels kurgu", "Motion grafik", "Ses tasarımı"],
  },
];

export const PACKAGES = [
  {
    id: "trend",
    name: "TREND",
    subtitle: "Sosyal Medya Yönetimi",
    oldPrice: "40.000",
    price: "30.000",
    highlight: false,
    features: [
      "10 Adet Profesyonel Post Tasarımı ve Paylaşımı",
      "15 Adet Hikaye Tasarımı ve Yönetimi",
      "Aylık İçerik Planlaması ve Paylaşım Takvimi",
      "6 Adet Profesyonel Reels Çekimi (Çekim + Kurgu)",
      "Sayfa Düzeni ve Profil Optimizasyonu",
      "Meta (Instagram & Facebook) Reklam Yönetimi",
      "Meta Business Suite Yönetimi",
      "Aylık Performans Analizi ve Raporlama",
    ],
  },
  {
    id: "populer",
    name: "POPÜLER",
    subtitle: "En Çok Tercih Edilen",
    oldPrice: "42.000",
    price: "35.000",
    highlight: true,
    features: [
      "20 Adet Profesyonel Post Tasarımı ve Paylaşımı",
      "8 Adet Profesyonel Reels Çekimi (Edit + Kurgu)",
      "İçerik Planlaması ve Aylık İçerik Takvimi",
      "25 Adet Hikaye Tasarımı ve Yönetimi",
      "Google İşletme Profili Yönetimi",
      "Meta Business Suite Yönetimi",
      "Meta (Instagram & Facebook) Reklam Yönetimi",
      "Sayfa Düzeni ve Profil Optimizasyonu",
      "Öne Çıkanlar Düzenlemesi",
      "Biyografi ve Rakip Analizi",
      "DM ve Mesaj Yönetimi",
      "Aylık Performans Takibi ve Raporlama",
    ],
  },
  {
    id: "fenomen",
    name: "FENOMEN",
    subtitle: "Maksimum Büyüme",
    oldPrice: "50.000",
    price: "39.999",
    highlight: false,
    features: [
      "30 Adet Profesyonel Post Tasarımı ve Paylaşımı",
      "10 Adet Profesyonel Reels Çekimi (Çekim + Kurgu)",
      "İçerik Planlaması ve Aylık İçerik Takvimi",
      "35 Adet Hikaye Tasarımı ve Yönetimi",
      "Google İşletme Profili Yönetimi",
      "Meta Business Suite Yönetimi",
      "Meta (Instagram & Facebook) Reklam Yönetimi",
      "Sayfa Düzeni ve Profil Optimizasyonu",
      "Öne Çıkanlar Düzenlemesi",
      "Biyografi ve Rakip Analizi",
      "DM ve Mesaj Yönetimi",
      "Aylık Performans Takibi ve Raporlama",
    ],
  },
];

export const GUARANTEES = [
  { title: "%100 Organik Takipçi", desc: "Bot yok. Tamamen gerçek ve organik büyüme.", icon: "ShieldCheck" },
  { title: "+5 Yıl Sektör Deneyimi", desc: "Alanında uzman, tecrübeli ekip.", icon: "Award" },
  { title: "Hesap Güvenliği", desc: "Hesabınız her zaman güvende ve kontrol sizde.", icon: "Lock" },
  { title: "Meta Yönetimi Dahil", desc: "Reklam ve Business Suite yönetimi pakete dahil.", icon: "Infinity" },
  { title: "Sonuç Odaklı", desc: "Takipçi değil, satış ve etkileşim hedefliyoruz.", icon: "TrendingUp" },
  { title: "Sonuç Veren Algoritma", desc: "Doğru zaman, doğru içerik, doğru kitle.", icon: "Zap" },
];

export const STATS = [
  { value: "100%", label: "Büyüme Garantisi" },
  { value: "5+", label: "Yıl Deneyim" },
  { value: "250+", label: "Yönetilen Hesap" },
  { value: "12M+", label: "Organik Erişim" },
];

export const CHAPTERS = [
  {
    no: "01",
    title: "Dijital Vizyon",
    body: "İzmir Medya, markaları sadece görünür değil; hatırlanır kılmak için doğdu. Her paylaşımın bir amacı, her karenin bir hikayesi var.",
  },
  {
    no: "02",
    title: "İzmir Stratejisi",
    body: "Ege'nin ruhunu dijitale taşıyoruz. Yerel içgörü, global standart. Şehrinizi tanıyan bir ekiple çalışmanın farkını yaşayın.",
  },
  {
    no: "03",
    title: "Prodüksiyon Sanatı",
    body: "Sinema kameraları, 4K drone'lar ve profesyonel kurgu. Ham fikirden viral içeriğe uzanan uçtan uca prodüksiyon.",
  },
];

export const IMAGES = {
  camera: "https://images.unsplash.com/photo-1649857114280-0df8879c9034?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxzb2NpYWwlMjBtZWRpYSUyMGNvbnRlbnQlMjBjcmVhdGlvbiUyMGNhbWVyYSUyMGRyb25lJTIwc3R1ZGlvfGVufDB8fHx8MTc4NzA4Nzg1NXww&ixlib=rb-4.1.0&q=85",
  drone: "https://images.unsplash.com/photo-1613682988402-9e2ec510b4cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxzb2NpYWwlMjBtZWRpYSUyMGNvbnRlbnQlMjBjcmVhdGlvbiUyMGNhbWVyYSUyMGRyb25lJTIwc3R1ZGlvfGVufDB8fHx8MTc4NzA4Nzg1NXww&ixlib=rb-4.1.0&q=85",
  editing: "https://images.pexels.com/photos/30051201/pexels-photo-30051201.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  statueArt: "https://images.unsplash.com/photo-1559122140-561ec33105f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2NzF8MHwxfHNlYXJjaHwzfHxzdGF0dWUlMjBuZW9uJTIwc2N1bHB0dXJlJTIwYWVzdGhldGljJTIwZGFyayUyMGFydHxlbnwwfHx8fDE3ODcwODc4Njh8MA&ixlib=rb-4.1.0&q=85",
  statuePortrait: "https://images.unsplash.com/photo-1670813885725-e3c5391dcd31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2NzF8MHwxfHNlYXJjaHwxfHxzdGF0dWUlMjBuZW9uJTIwc2N1bHB0dXJlJTIwYWVzdGhldGljJTIwZGFyayUyMGFydHxlbnwwfHx8fDE3ODcwODc4Njh8MA&ixlib=rb-4.1.0&q=85",
  izmirCoast: "https://images.unsplash.com/photo-1676845720835-0f01a82c7295?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxpem1pciUyMHR1cmtleSUyMHNlYSUyMGNvYXN0bGluZSUyMHN1bnNldCUyMGNpdHl8ZW58MHx8fHwxNzg3MDg3ODY4fDA&ixlib=rb-4.1.0&q=85",
  izmirSunset: "https://images.unsplash.com/photo-1594029648924-becc7778b980?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxpem1pciUyMHR1cmtleSUyMHNlYSUyMGNvYXN0bGluZSUyMHN1bnNldCUyMGNpdHl8ZW58MHx8fHwxNzg3MDg3ODY4fDA&ixlib=rb-4.1.0&q=85",
};
